import {useState, useEffect} from 'react'
import type {DeviceListItem} from '../api/generated/model/deviceListItem'
import {listDevices} from '../api/generated/endpoints/devices/devices'

export type {DeviceListItem}

/** Fetches device list from the API, optionally filtered to free-only */
export const useDeviceCatalog = (freeOnly?: boolean) => {
  const [devices, setDevices] = useState<DeviceListItem[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const {data} = await listDevices(freeOnly ? {free: true} : undefined)
        setDevices(data)
      } finally {
        setLoading(false)
      }
    }

    fetchDevices()
  }, [freeOnly])

  return {devices, loading}
}
